module.exports = __webpack_public_path__ + "img/ruler-triangle.42c4a539.svg";